function scorecard_list_autofill(data)
{
	$( document ).ready(function() {
		if(typeof data != 'undefined')
		{
			var options = {
				'data':data,
				'getValue':'company',
				'dataType': "json",
				'list': {
					'match': {
						'enabled': true
					},
					'maxNumberOfElements': 10,
					onChooseEvent: function() {
						var selectedItem = $("#compare_search_field").getSelectedItemData();
						add_company_to_compare(selectedItem.ticker, selectedItem.short_name, selectedItem.industry_name);
						return false
					},
					onHideListEvent: function() {

					}
				},
				'template': {
					'type':'custom',
					'method': function (value, item) {
						return '<span class="s-1">' + value + '</span>'
					}
				}
			}
			$('#compare_search_field').easyAutocomplete(options);
		}
	});
}

function add_company_to_compare(ticker, company_name, industry_name)
{
	var current_companies = $('.company_compare_panel .company_badge').map(function(i, e) {return $(e).attr('data-ticker')}).toArray();
	if(current_companies.length<=2)
	{
		var tempHTML = '<span class="company_badge" data-ticker="'+ticker+'">'
		tempHTML+= '<i class="fa fa-times" onclick="$(this).parent().remove()"></i>'
		tempHTML+= '<div class="company_logo">'
		tempHTML+= '<img src="/wp-content/themes/justcapital/assets/img/company-logos/'+ticker+'.png" />'
		tempHTML+= '</div>'
		tempHTML+= '<div class="company_name"><strong>'+company_name+'</strong></div>'
		tempHTML+= '<div class="industry_name">'+industry_name+'</div>'
		tempHTML+= '</span>'
		$(".company_compare_panel .company_list").append(tempHTML)
	}
	else
	{
		alert("You can compare only 3 companies at a time.")
		return false
	}
}

function compare_companies(url_prefix)
{
	var current_companies = $('.company_compare_panel .company_badge').map(function(i, e) {return $(e).attr('data-ticker')}).toArray();
	if(current_companies.length>0)
	{
		window.location=url_prefix+'?co='+current_companies.join();
	}
}

function switch_benchmark_threshold(view)
{
	$(".benchmark_thresholds a.active").removeClass("active");
	$("."+view+"_benchmark_btn").addClass("active");
	$(".company_benchmark_info").hide();
	$(".industry_benchmark_info").hide();
	$(".overall_benchmark_info").hide();
	$("."+view+"_benchmark_info").show();
}




$( document ).ready(function() {
	$(window).scroll(function(){
		var scrolled_px = document.body.scrollTop || document.documentElement.scrollTop;
		if(scrolled_px>500)
		{
			$("#back_up_btn").show()
		}
		else
		{
			$("#back_up_btn").hide()
		}
	});
});